<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.coalUploadRecord.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div class="handle-headright">
            <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="$t('pages.coalUploadRecord.rangeSeparator')" :start-placeholder="$t('pages.coalUploadRecord.startDate')" :end-placeholder="$t('pages.coalUploadRecord.endDate')" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>
            <el-select v-model="query.upType" :placeholder="$t('pages.coalUploadRecord.recordType')" class="handle-select mr10">
                <el-option key :label="$t('pages.coalUploadRecord.all')" value></el-option>
                <el-option key="0" :label="$t('pages.coalUploadRecord.fail')" value="0"></el-option>
                <el-option key="1" :label="$t('pages.coalUploadRecord.success')" value="1"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.coalUploadRecord.search')}}</el-button>
        </div>

        <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" width="50" :label="$t('pages.coalUploadRecord.index')"></el-table-column>
            <el-table-column sortable prop="UpTime" :label="$t('pages.coalUploadRecord.uploadTime')" width="160">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.upTime | formateData }}
                </template>
            </el-table-column>
            <el-table-column sortable prop="moduleName" :label="$t('pages.coalUploadRecord.apiName')" width="300"></el-table-column>
            <el-table-column prop="upType" :label="$t('pages.coalUploadRecord.result')" width="100">
                <template slot-scope="scope">
                    <el-tag :type="UpTypeColor(scope.row.upType)" disable-transitions>{{ scope.row.upType | UpTypeFormat }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="content" :label="$t('pages.coalUploadRecord.code')" width="100">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start" :title="$t('pages.coalUploadRecord.detail')" width="450">
                        <p>{{ scope.row.content }}</p>
                        <div slot="reference" class="name-wrapper">{{ scope.row.code | ContentFormat }}</div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="content" :label="$t('pages.coalUploadRecord.msg')" width="200">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start" :title="$t('pages.coalUploadRecord.detail')" width="450">
                        <p>{{ scope.row.content }}</p>
                        <div slot="reference" class="name-wrapper">{{ scope.row.msg | ContentFormat }}</div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="content" :label="$t('pages.coalUploadRecord.content')" width="975">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top-start" :title="$t('pages.coalUploadRecord.detail')" width="450">
                        <p>{{ scope.row.content }}</p>
                        <div slot="reference" class="name-wrapper">{{ scope.row.content | ContentFormat }}</div>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField
} from '../../utils/helper';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [{
                        text: '当天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            pageCount: 1,
            tableHeight: window.innerHeight * 0.55,
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                upType: '',
                PageIndex: 1,
                PageSize: 15
            }
        };
    },
    filters: {
        UpTypeFormat(Type) {
            var Name = '';
            if (Type == '0') {
                Name = '失败';
            } else if (Type == '1') {
                Name = '成功';
            }
            return Name;
        },
        ContentFormat(content) {
            if (content.length >= 50) {
                content = content.substr(0, 60) + '...';
            }
            return content;
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000);
        this.query.daterange = [start, end];
        this.getData();
    },
    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.coalUploadRecord.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            this.$zybhttp
                .post('DataInquiry/CoalInforUploadSearch', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        this.logRecords = d;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.coalUploadRecord.fetchError')));
        },
        UpTypeColor(Type) {
            var Name = '';
            if (Type == '0') {
                Name = 'danger';
            } else if (Type == '1') {
                Name = 'success';
            }
            return Name;
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
